import React, { createContext, useMemo, useState } from 'react';
import { node } from 'prop-types';
import { addMonths, format, startOfMonth } from 'date-fns';

// Create a context with default values
export const SubscriptionsContext = createContext();

// Create a provider (wrapper that handles the logic)
// This also allows communication to context and update
// state values throughout app with user info
const SubscriptionsWizard = props => {
  const { children } = props;
  const steps = useMemo(
    () => [
      {
        id: 1,
        stepLabel: 'Affiliate List',
      },
      {
        id: 2,
        stepLabel: 'Volume Tier',
      },
      {
        id: 3,
        stepLabel: 'Order Summary',
      },
    ],
    []
  );
  // Any useStates here can easily be passed to any component
  // via the value prop for the Provider, then accessed
  // through useContext in the children components
  // Global State Data for Wizards
  const initialData = useMemo(
    () => ({
      effectiveDate: format(startOfMonth(addMonths(new Date(), 1)), 'MMMM d, yyyy'),
      endDate: format(startOfMonth(addMonths(new Date(), 13)), 'MMMM d, yyyy'),
      globalAffiliatesVolumes: [],
      globalCustomer: null,
      loadGlobalAffiliatesVolumes: true,
      loadGlobalCustomers: true,
      loadTierDetails: true,
      planSelected: {
        contractID: null,
        overageRate: null,
        tierFixedFee: null,
        tierPlanName: null,
        tierRate: null,
        tierVolume: null,
      },
      selectedAffiliate: {},
    }),
    []
  );
  const [data, setData] = useState(initialData);
  const [currentStep, setCurrentStep] = useState(0);

  const contextValue = useMemo(
    () => ({
      currentStep,
      data,
      initialData,
      setCurrentStep,
      setData,
      steps,
    }),
    [currentStep, data, initialData, steps]
  );

  // Handling the step updating and also updating
  // the stepper progress as we move along the wizard
  return (
    <>
      <SubscriptionsContext.Provider
        // Any item passed in this value prop
        // can be accessed in any child component
        // this should be used for variables/functions
        // that need to be accessed in individual
        // components, not for global variables/functions
        value={contextValue}
      >
        {children}
      </SubscriptionsContext.Provider>
    </>
  );
};

SubscriptionsWizard.propTypes = {
  children: node.isRequired,
};

export default SubscriptionsWizard;
